 
 <template>
  <material-card color="gray" title="Audit Trail">
    <v-data-table
      :headers="headersAuditTrail"
      :items="audittrail"
      :total-items="totalAuditTrail"
      :pagination.sync="paginationAuditTrail"
      :rows-per-page-items="[5, 10, 20]"
      class="dataTable"
      item-key="insert_at"
    >
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="font-weight-light left text-primary text--darken-3"
          v-text="header.text"
        />
      </template>

      <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column',
              header.align ? 'text-xs-' + header.align : 'text-xs-left',
              paginationAuditTrail.descending ? 'desc' : 'asc',
              header.sortable != false ? 'sortable' : '',
              header.value === paginationAuditTrail.sortBy ? 'active' : '',
            ]"
            @click="
              if (header.sortable != false) {
                changeSort(header.value);
              }
            "
          >
            <v-icon v-if="header.sortable != false" small>mdi-menu-down</v-icon>
            <span
              class="subheading font-weight-dark text-success text-darken-3"
              v-text="header.text"
            ></span>
          </th>
        </tr>

        <tr class="lighten-3">
          <th v-for="header in props.headers" :key="header.text">
            <div v-if="filtersAuditTrail.hasOwnProperty(header.value)">
              <v-text-field
                clearable
                md4
                v-if="filtersAuditTrail[header.value].type == 'text'"
                v-model="filtersAuditTrail[header.value].value"
                :placeholder="filtersAuditTrail[header.value].placeholder"
              />

              <v-select
                clearable
                md4
                v-if="filtersAuditTrail[header.value].type == 'list'"
                v-model="filtersAuditTrail[header.value].value"
                :items="filtersAuditTrail[header.value].list"
                :placeholder="filtersAuditTrail[header.value].placeholder"
                class="purple-input"
              ></v-select>

              <v-autocomplete
                clearable
                md4
                v-if="filtersAuditTrail[header.value].type == 'autocomplete'"
                v-model="filtersAuditTrail[header.value].value"
                :items="filtersAuditTrail[header.value].list"
                :item-value="filtersAuditTrail[header.value].item_value"
                :item-text="filtersAuditTrail[header.value].item_text"
                :placeholder="filtersAuditTrail[header.value].placeholder"
                class="purple-input"
                :search-input.sync="searchAutocomplete[header.value]"
              ></v-autocomplete>

              <v-menu
                v-if="filtersAuditTrail[header.value].type == 'date'"
                v-model="filtersAuditTrail[header.value].datePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template slot="activator">
                  <v-text-field
                    clearable
                    v-model="filtersAuditTrail[header.value].value"
                    :label="filtersAuditTrail[header.value].placeholder"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  dark
                  v-model="filtersAuditTrail[header.value].value"
                  no-title
                  @input="filtersAuditTrail[header.value].datePicker = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </th>
        </tr>
      </template>

      <template slot="items" slot-scope="{ item }">
        <tr
          @click="
            item.expanded = !item.expanded;
            expandedItem = item;
          "
         :class="item.expanded ? 'expanded' : ''"
        >
          <td v-for="header in headersAuditTrail" v-bind:key="header.value"  :class="item.expanded ? 'expanded' : ''">
            {{ header.render ? header.render(item) : item[header.value] }}
          </td>
        </tr>

        <tr v-if="item.expanded">
          <td :colspan="headersAuditTrail.length" style="background: lightgray">
            <!--v-card color="black" dark flat tile>
              <v-window v-model="expandedItem.onboarding">
                <v-window-item v-for="i in item.data.length" :key="`card-${i}`">
                  <v-card color="transparent" height="200">
                    <v-layout
                      align-center
                      justify-center
                      fill-height
                      tag="v-card-text"
                    >
                      {{ item.data[i - 1] }}
                    </v-layout>
                  </v-card>
                </v-window-item>
              </v-window>

              <v-card-actions class="justify-space-between">
                <v-btn flat @click="prev">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-item-group
                  v-model="expandedItem.onboarding"
                  class="text-xs-center"
                  mandatory
                >
                  <v-item v-for="i in item.data.length" :key="`btn-${i}`">
                    <v-btn
                      slot-scope="{ active, toggle }"
                      :input-value="active"
                      icon
                      @click="toggle"
                    >
                      <v-icon>mdi-record</v-icon>
                    </v-btn>
                  </v-item>
                </v-item-group>
                <v-btn flat @click="next">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card-->

            <v-timeline align-top dense>
              <v-timeline-item
                v-for="(dd, i) in item.data"
                :key="i"
                color="red lighten-2"
                small
              >
               <!--template slot="icon">
                <span>test</span>
                </template-->
                <v-card class="elevation-2">
                  <v-card-title class="headline" style="display:block"
                    >  <b style="font-size:0.7em;line-height:20px">{{ dd[0] }} &nbsp; {{ dd[1] }}</b>   <v-text-field label="Search" v-model="dd[3]" clearable :full-width="false" style="margin:0px;padding:0px;float:right" /> </v-card-title
                  >
                  <v-card-text>
                      <v-chip :color="dd[3] && k.includes(dd[3]) ? 'green' : 'gray'" v-for="(d,k) in dd[2]" v-bind:key="k"><b>{{k}}</b>: {{d}}</v-chip>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </td>
        </tr>
      </template>
    </v-data-table>
  </material-card>
</template>



<script>
import { getList } from "@/api/base_api";
import { normalizeFilters } from "@/utils/filters";
import dayjs from "dayjs";

export default {
  data() {
    return {
      filtersAuditTrail: {
         entity: {
          type:'list',
          value: undefined,
          placeholder: 'Choose',
          list: ['adverse_event', 'pregnancy', 'spm', 'site', 'treatment', 'qualitycheck', 'external_user', 'company_user']
        },
        entity_id: {
          type:'text',
          value: undefined,
          placeholder: 'Search'
        },
      },
      paginationAuditTrail: {
        rowsPerPage: 5,
        page: 1,
        sortBy: "insert_at",
        descending: true,
      },
      audittrail: [],
      totalAuditTrail: 0,
      headersAuditTrail: [
        {
          sortable: false,
          text: "Entity",
          value: "entity",
        },
        {
          sortable: false,
          text: "Entity ID",
          value: "entity_id",
        },
        {
          sortable: false,
          text: "Update",
          value: "tot",
        },
      ],
      expandedItem: null,
    };
  },
  async mounted() {
    this.getData();
  },
  watch: {
    paginationAuditTrail: {
      handler(val, oldVal) {
        if (oldVal.totalItems){
          this.getData()
        }
      },
      deep: false
    },
    filtersAuditTrail: {
      handler(val) {
        this.paginationAuditTrail.page = 1
        this.getData()
      },
      deep: true
    },
  },
  methods: {
    async getData() {

      const filters = normalizeFilters(JSON.parse(JSON.stringify(this.filtersAuditTrail)))

      const ret = await getList(
        "audittrail",
        filters,
        this.paginationAuditTrail
      );

      this.paginationAuditTrail.rowsPerPage = ret.perPage
      this.paginationAuditTrail.page = ret.currentPage
      this.paginationAuditTrail.totalItems = ret.tot

      ret.data.forEach(function (el) {
        el.expanded = false;
        el.onboarding = 0;
      });
      this.totalAuditTrail = ret.tot;
      this.audittrail = ret.data;
    },
    prev() {
      this.expandedItem.onboarding =
        this.expandedItem.onboarding == 0
          ? this.expandedItem.data.length - 1
          : this.expandedItem.onboarding - 1;
    },
    next() {
      this.expandedItem.onboarding =
        this.expandedItem.onboarding == this.expandedItem.data.length - 1
          ? 0
          : this.expandedItem.onboarding + 1;
    },
  },
};
</script>


<style lang="scss">
    .expanded {
        background:rgb(158, 158, 158);
        font-weight:bold !important;
    }
</style>